import { render, staticRenderFns } from "./LeadsDashboard.vue?vue&type=template&id=f5f8b6ec&scoped=true&"
import script from "./LeadsDashboard.vue?vue&type=script&lang=js&"
export * from "./LeadsDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5f8b6ec",
  null
  
)

export default component.exports